import { GlAlert, GlButton, GlAnimatedChevronLgDownUpIcon, GlCollapse } from '@gitlab/ui';
import { __, n__, sprintf } from '~/locale';
import CrudComponent from '~/vue_shared/components/crud_component.vue';
import AgentSessionsGroup from './agent_sessions_group.vue';
import { SESSION_OTHER_GROUPS, SESSION_AWAITING_INPUT_GROUP, AWAITING_INPUT_HEADER_BG_CLASS, OTHER_GROUP_HEADER_BG_CLASS } from './constants';
const mapGroup = ({ statuses, title }, sessions, headerBgClass)=>{
    const groupSessions = sessions.filter((s)=>statuses.includes(s.status));
    return {
        key: statuses[0],
        sessions: groupSessions,
        representativeSession: groupSessions[0],
        title: sprintf(n__('DuoAgentPlatform|%{count} session %{title}', 'DuoAgentPlatform|%{count} sessions %{title}', groupSessions.length), {
            count: groupSessions.length,
            title
        }),
        headerBgClass
    };
};
export default {
    name: 'AgentSessionsList',
    components: {
        CrudComponent,
        GlAlert,
        GlButton,
        GlAnimatedChevronLgDownUpIcon,
        GlCollapse,
        AgentSessionsGroup
    },
    props: {
        sessions: {
            type: Array,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false
        },
        showEmptyState: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            otherCollapsed: true
        };
    },
    computed: {
        hasSessions () {
            return this.sessions.length > 0;
        },
        isVisible () {
            return this.hasSessions || this.hasError || this.showEmptyState;
        },
        isCollapsed () {
            // Errors and sessions awaiting input stay expanded; an empty list collapses to the header.
            return !this.hasError && !this.awaitingInputGroup;
        },
        sessionCount () {
            return this.sessions.length || null;
        },
        awaitingInputGroup () {
            const group = mapGroup({
                ...SESSION_AWAITING_INPUT_GROUP,
                title: SESSION_AWAITING_INPUT_GROUP.title.toLowerCase()
            }, this.sessions, AWAITING_INPUT_HEADER_BG_CLASS);
            return group.sessions.length ? {
                ...group,
                showViewDetails: true
            } : null;
        },
        otherSessionGroups () {
            return SESSION_OTHER_GROUPS.map((groupDef)=>({
                    ...mapGroup({
                        ...groupDef,
                        title: groupDef.title.toLowerCase()
                    }, this.sessions, OTHER_GROUP_HEADER_BG_CLASS),
                    rawTitle: groupDef.title.toLowerCase(),
                    showViewDetails: false
                })).filter(({ sessions })=>sessions.length > 0);
        },
        hasOtherSessions () {
            return this.otherSessionGroups.length > 0;
        },
        otherGroupsSummary () {
            return this.otherSessionGroups.map(({ sessions, rawTitle })=>sprintf(__('%{count} %{label}'), {
                    count: sessions.length,
                    label: rawTitle
                })).join(' · ');
        },
        otherToggleLabel () {
            return this.otherCollapsed ? __('Show') : __('Hide');
        }
    }
};
